"use strict";
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const router_1 = require("@angular/router");
class RoutingDisabler {
    constructor(_router) {
        this._router = _router;
        this._sub = _router.events.subscribe(this.handleRouterEvent.bind(this));
    }
    reEnable() {
        this._sub.unsubscribe();
    }
    handleRouterEvent(ev) {
        if (ev instanceof router_1.NavigationStart && ev.url !== this._router.url) {
            this._router.navigateByUrl(this._router.url);
        }
    }
}
exports.RoutingDisabler = RoutingDisabler;
